import { render, staticRenderFns } from "./ViewerPanelComments.vue?vue&type=template&id=15ff9dfd&scoped=true"
import script from "./ViewerPanelComments.vue?vue&type=script&lang=js"
export * from "./ViewerPanelComments.vue?vue&type=script&lang=js"
import style0 from "./ViewerPanelComments.vue?vue&type=style&index=0&id=15ff9dfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ff9dfd",
  null
  
)

export default component.exports